import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { handleError } from '../../../../../utils/admin';
import { DocumentParams } from '../../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplication } from '../../requests/getApplication';

export const useApplication = (
  uuid: string,
  documentParams: DocumentParams,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean; refetchOnWindowFocus?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplication>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, documentParams, params],
    queryFn: () => getApplication(constructGet, uuid, documentParams, params),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    onError: () => handleError('Could not load applicant data'),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'application'),
    ...rest,
  };
};
